import { inject, Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
	CanActivateFn,
	CanActivateChildFn,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionStore } from '../store/session.store';

@Injectable({
	providedIn: 'root',
})
export class AuthorizedGuard {
	private _store = inject(SessionStore);
	private _router = inject(Router);

	canActivate: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
		return this.check(state.url);
	};

	canActivateChild: CanActivateChildFn = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
		return this.check(state.url);
	};

	private check(redirect: string): Observable<boolean> {
		const token = this._store.token();
		if (!!token) {
			return new Observable<boolean>((observer) => {
				observer.next(true);
				observer.complete();
			});
		} else {
			if (redirect) {
				this._router.navigate(['/auth/login'], { queryParams: { redirect } });
			} else {
				this._router.navigate(['/']);
			}
			return new Observable<boolean>((observer) => {
				observer.next(false);
				observer.complete();
			});
		}
	}
}
